import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué es el tratamiento SAINT® para la depresión?",
    answer:
      "SAINT® es una TMS acelerada con orientación por fMRI que se administra en 50 sesiones durante cinco días para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  },
];

export const esWhatIsSaintTreatment = makeEsArticle({
  slug: "what-is-saint-treatment-for-depression",
  title: "¿Qué es el tratamiento SAINT® para la depresión?",
  description:
    "SAINT® es una TMS acelerada con orientación por fMRI, administrada en 50 sesiones durante cinco días para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  h1: "¿Qué es el tratamiento SAINT® para la depresión?",
  breadcrumbLabel: "Tratamiento SAINT® para la depresión",
  shortAnswer:
    "SAINT® (Stanford Accelerated Intelligent Neuromodulation Therapy) es un protocolo de estimulación magnética transcraneal acelerada con orientación individualizada por fMRI. Se administra en 50 sesiones durante cinco días consecutivos para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SAINT® está autorizada por la FDA (510(k) K220177, septiembre de 2022) para este uso. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  keyTakeaways: [
    "SAINT® es TMS acelerada con orientación por fMRI.",
    "Se administra en 50 sesiones durante cinco días.",
    "Está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
    "Está indicada para adultos que no han mejorado con antidepresivos.",
    "La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  ],
  sections: [
    {
      heading: "El protocolo SAINT®",
      paragraphs: [
        "SAINT® combina tres elementos: orientación individualizada por fMRI para localizar el circuito cerebral asociado con la depresión, estimulación theta burst en lugar de estimulación convencional, y un calendario acelerado de 50 sesiones durante cinco días. Cada día incluye aproximadamente 10 sesiones, cada una de unos minutos, con descansos de aproximadamente 50 minutos.",
      ],
    },
    {
      heading: "Autorización de la FDA",
      paragraphs: [
        "SAINT® está autorizada por la FDA (510(k) K220177, septiembre de 2022) para el trastorno depresivo mayor en adultos que no han logrado una mejoría satisfactoria con antidepresivos en el episodio actual. No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "U.S. Food and Drug Administration. 510(k) Premarket Notification — Magnus Neuromodulation System with SAINT Technology (K220177, September 2022).",
      url: "https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfpmn/pmn.cfm",
    },
    {
      citation:
        "Cole EJ, et al. Stanford Neuromodulation Therapy (SNT): A Double-Blind Randomized Controlled Trial. Am J Psychiatry. 2022;179(2):132-141.",
      url: "https://doi.org/10.1176/appi.ajp.2021.20101429",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
